/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateIsotopoFormDto } from '../models/create-isotopo-form-dto';
import { IsotopoCriteriaDto } from '../models/isotopo-criteria-dto';
import { IsotopoDto } from '../models/isotopo-dto';
import { IsotopoPageDto } from '../models/isotopo-page-dto';
import { UpdateIsotopoFormDto } from '../models/update-isotopo-form-dto';


/**
 * Isotopos
 */
@Injectable({
  providedIn: 'root',
})
export class IsotoposService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getIsotopos
   */
  static readonly GetIsotoposPath = '/isotopos';

  /**
   * Pesquisar isotopos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIsotopos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIsotopos$Response(params?: {
    criteria?: IsotopoCriteriaDto;
  }): Observable<StrictHttpResponse<IsotopoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, IsotoposService.GetIsotoposPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsotopoPageDto>;
      })
    );
  }

  /**
   * Pesquisar isotopos.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getIsotopos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIsotopos(params?: {
    criteria?: IsotopoCriteriaDto;
  }): Observable<IsotopoPageDto> {

    return this.getIsotopos$Response(params).pipe(
      map((r: StrictHttpResponse<IsotopoPageDto>) => r.body as IsotopoPageDto)
    );
  }

  /**
   * Path part for operation createIsotopo
   */
  static readonly CreateIsotopoPath = '/isotopos';

  /**
   * Criar isotopo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createIsotopo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createIsotopo$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateIsotopoFormDto
  }): Observable<StrictHttpResponse<IsotopoDto>> {

    const rb = new RequestBuilder(this.rootUrl, IsotoposService.CreateIsotopoPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsotopoDto>;
      })
    );
  }

  /**
   * Criar isotopo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createIsotopo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createIsotopo(params?: {

    /**
     * apiRequest
     */
    body?: CreateIsotopoFormDto
  }): Observable<IsotopoDto> {

    return this.createIsotopo$Response(params).pipe(
      map((r: StrictHttpResponse<IsotopoDto>) => r.body as IsotopoDto)
    );
  }

  /**
   * Path part for operation getIsotopo
   */
  static readonly GetIsotopoPath = '/isotopos/{id}';

  /**
   * Obter isotopo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIsotopo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIsotopo$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<IsotopoDto>> {

    const rb = new RequestBuilder(this.rootUrl, IsotoposService.GetIsotopoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsotopoDto>;
      })
    );
  }

  /**
   * Obter isotopo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getIsotopo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIsotopo(params: {
    id: number;
  }): Observable<IsotopoDto> {

    return this.getIsotopo$Response(params).pipe(
      map((r: StrictHttpResponse<IsotopoDto>) => r.body as IsotopoDto)
    );
  }

  /**
   * Path part for operation updateIsotopo
   */
  static readonly UpdateIsotopoPath = '/isotopos/{id}';

  /**
   * Atualizar isotopo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateIsotopo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateIsotopo$Response(params: {
    id: number;
    body?: UpdateIsotopoFormDto
  }): Observable<StrictHttpResponse<IsotopoDto>> {

    const rb = new RequestBuilder(this.rootUrl, IsotoposService.UpdateIsotopoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsotopoDto>;
      })
    );
  }

  /**
   * Atualizar isotopo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateIsotopo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateIsotopo(params: {
    id: number;
    body?: UpdateIsotopoFormDto
  }): Observable<IsotopoDto> {

    return this.updateIsotopo$Response(params).pipe(
      map((r: StrictHttpResponse<IsotopoDto>) => r.body as IsotopoDto)
    );
  }

  /**
   * Path part for operation ativarIsotopo
   */
  static readonly AtivarIsotopoPath = '/isotopos/{id}/ativar';

  /**
   * Ativar Isotopo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarIsotopo()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarIsotopo$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<IsotopoDto>> {

    const rb = new RequestBuilder(this.rootUrl, IsotoposService.AtivarIsotopoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsotopoDto>;
      })
    );
  }

  /**
   * Ativar Isotopo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarIsotopo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarIsotopo(params: {
    id: number;
  }): Observable<IsotopoDto> {

    return this.ativarIsotopo$Response(params).pipe(
      map((r: StrictHttpResponse<IsotopoDto>) => r.body as IsotopoDto)
    );
  }

  /**
   * Path part for operation desativarIsotopo
   */
  static readonly DesativarIsotopoPath = '/isotopos/{id}/desativar';

  /**
   * Desativar isotopo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarIsotopo()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarIsotopo$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<IsotopoDto>> {

    const rb = new RequestBuilder(this.rootUrl, IsotoposService.DesativarIsotopoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsotopoDto>;
      })
    );
  }

  /**
   * Desativar isotopo.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarIsotopo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarIsotopo(params: {
    id: number;
  }): Observable<IsotopoDto> {

    return this.desativarIsotopo$Response(params).pipe(
      map((r: StrictHttpResponse<IsotopoDto>) => r.body as IsotopoDto)
    );
  }

}
